var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              id: "budget-spending-detail-list",
              items: _vm.list,
              fields: _vm.fields,
              bordered: "",
              responsive: "",
              "current-page": _vm.currentPage,
              "per-page": 10
            },
            scopedSlots: _vm._u([
              {
                key: "head()",
                fn: function(data) {
                  return [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t(data.label)) + "\n        "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.list ? _vm.list.length : 0,
              "per-page": 10,
              "aria-controls": "budget-spending-detail-list"
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-050af60e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050af60e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BudgetMaster/BudgetSpendingDetail.vue
// module id = null
// module chunks = 